import { Link } from "react-router-dom";

const friendLinks = [
  { label: "影视资讯站", href: "https://hbsfkj.cn/news" },
  { label: "影评社区", href: "https://hbsfkj.cn/reviews" },
  { label: "购票指南", href: "https://hbsfkj.cn/tickets" },
  { label: "行业观察", href: "https://hbsfkj.cn/industry" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold">可可影视</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80">
              专业影视资讯平台，汇聚最新电影电视剧内容与评分推荐，帮助你轻松发现优质影视作品。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm">
              <li><Link to="/" className="text-primary-100/80 transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/movies" className="text-primary-100/80 transition-colors hover:text-accent-400">电影</Link></li>
              <li><Link to="/tvseries" className="text-primary-100/80 transition-colors hover:text-accent-400">电视剧</Link></li>
              <li><Link to="/search" className="text-primary-100/80 transition-colors hover:text-accent-400">搜索</Link></li>
              <li><Link to="/about" className="text-primary-100/80 transition-colors hover:text-accent-400">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">友情链接</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-100/80 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-primary-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400"></i>
                contact@kekefilm.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base text-accent-400"></i>
                400-000-0000
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base text-accent-400"></i>
                上海市浦东新区影创路 88 号
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start gap-3 border-t border-primary-800 pt-6 text-xs text-primary-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 可可影视 KekeFilm. 保留所有权利。本站内容为演示数据，仅供展示。</p>
          <p className="flex items-center gap-4">
            <span className="cursor-pointer transition-colors hover:text-accent-400">隐私政策</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">用户协议</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">版权声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}